var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 1920,
    height: 1080,
    fill: "url(#paint0_linear_3000_257218)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 509.501C0 509.501 93.5 767.001 184.5 719.001C260.803 678.753 336 536.001 408 536.001C480 536.001 538 700.501 684.5 700.501C831 700.501 1035.5 335.82 1164 335.82C1292.5 335.82 1383.5 600.001 1468 600.001C1552.5 600.001 1621.5 425.001 1709 425.001C1796.5 425.001 1920 630.001 1920 630.001V1080H0V509.501Z",
    fill: "white",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 823.035C0 823.035 90.1088 496.579 252.5 489.5C413 489.5 520.5 781 669 781C817.5 781 1005 319.5 1135 449.5C1265 579.5 1256 283.5 1411 283.5C1566 283.5 1524 687.074 1761.57 449.5C1856.46 347.104 1920 522.5 1920 522.5V1080H0V823.035Z",
    fill: "white",
    fillOpacity: 0.07
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0 712.5C0 712.5 54.8382 442 154.5 442C245.001 442 355.24 696.5 467.74 696.5C580.24 696.5 689.5 370.831 886 370.831C1082.5 370.831 1176.5 665.175 1336 665.175C1495.5 665.175 1535.5 370.831 1624 370.831C1690 370.831 1731.5 541 1798.5 541C1881.5 541 1920 295 1920 295V1080H0V712.5Z",
    fill: "url(#paint1_linear_3000_257218)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3000_257218",
    x1: 0.0965401,
    y1: 1079.98,
    x2: 2055.07,
    y2: 421.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED0973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF744E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3000_257218",
    x1: 0.0965401,
    y1: 1079.99,
    x2: 1897.38,
    y2: 243.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED0973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF744E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.60879a8164cf9b3b930d840b7985d62b.svg";
export { ForwardRef as ReactComponent };